<template>
  <div class="back">
    <q-icon name="fa-solid fa-arrow-left" class="back__icon" />
    Назад
    <PopupConfirm
      v-if="!!this.approve && this.approveMode"
      :title="this.approveTitle || 'Подтвердите действие'"
      :approve="this.approve"
    />
  </div>
</template>

<script>
import PopupConfirm from "@/components/common/PopupConfirm";
export default {
  name: "BackBtn",
  components: {PopupConfirm},
  props: ['approve', 'approveTitle', 'approveMode']
}
</script>

<style scoped lang="scss">
.back {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  width: fit-content;
  transition: all 0.4s;
  font-size: 14px;
  color: #4d4d4d;
  font-weight: 500;

  &:hover {
    color: #1e3fac;
  }

  &__icon {
    font-size: 16px;
  }
}
</style>
